<style src="./UserList.scss" lang="scss"></style>
<template>
  <section class="user-list mail-box-header">
    <span class="title">
      <h3>Usuários</h3>
    </span>

    <ul class="userlist">
      <li
        class="item"
        :class="{ selected__item: selected === consumer.userToken }"
        v-for="(consumer, consumerIdx) in users"
        :key="consumerIdx"
        @click="selectUser(consumer.userToken)"
      >
        <div class="rightContent">
          <div
            class="status"
            :class="{ status__unread: consumer.isReceived }"
          ></div>
          <span class="name">{{ consumer.fullName }}</span>
        </div>
        <button
          class="close"
          @click.stop="closeConversation(consumer.userToken)"
        >
          <i class="fa fa-times"></i>
          <span class="closeText"
            >fechar<br />
            conversa</span
          >
        </button>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import socket from '@/store/socket';
import { MESSAGES_EVENTS } from '@/config/config';

export default {
  // name: "UserList",
  data: () => ({
    selected: '',
  }),
  computed: {
    ...mapGetters({
      users: 'MESSAGES/consumerOpenMessages',
    }),
  },
  watch: {
    '$route.params.userToken': {
      handler(v) {
        if (v) {
          this.watchUserToken(v);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$store.dispatch('MESSAGES/WatchConsumer');
    this.loadConsumers();
  },
  beforeDestroy() {
    this.$store.commit('MESSAGES/consumerMessages', []);
  },
  methods: {
    async loadConsumers() {
      try {
        await this.$store.dispatch('MESSAGES/LoadConsumerHelpRequest');
      } catch (error) {
        this.$toasted.error('Não foi possível listar os usuários');
      }
    },
    watchUserToken(userToken) {
      this.$store.dispatch('MESSAGES/WatchConsumerMessages', userToken);
    },
    selectUser(userToken) {
      this.selected = userToken;
      this.$router.replace({
        name: 'ConsumerMessageAttendance',
        params: { userToken },
      });
    },
    async closeConversation(userToken) {
      try {
        await this.$store.dispatch('MESSAGES/CloseConsumerConversation', {
          userToken,
        });
        await this.loadConsumers();
        this.$store.commit('MESSAGES/consumerMessages', []);
        this.$router.replace({
          name: 'ConsumerMessage',
        });
        socket.off(MESSAGES_EVENTS.CONSUMER_PRIVATE_MESSAGE);
      } catch (error) {
        this.$toasted.error('Falha ao finalizar conversa.');
      }
    },
  },
};
</script>
